import BaseContainer from "@base/container/BaseContainer";
import {Signals} from "@/Imports";
import Utils from "@base/utils/Utils";
import SpineAnimation from "@base/spineAnimation/SpineAnimation";

export default class AnimatedBackgroundContainer extends BaseContainer {

  constructor(objects, settings) {
    super()
    this.settings = settings
    this.init(objects)
  }

  init(objects) {
    Signals.makeBets.add(this.onMakeBets, this)
    Signals.roundStart.add(this.onRoundStart, this)
    Signals.roundEnd.add(this.onRoundEnd, this)

    this.objects = []

    for (let i = 0; i < objects.length; i++) {
      let o
      if(this.isSpine) {
        o = new SpineAnimation(objects[i])
      } else {
        o = new PIXI.Sprite(PIXI.Texture.from(objects[i]))
      }

      o.scale.set(this.settings.sc)
      o.position.set(this.settings.startX, this.settings.startY)
      this.addChild(o)
      this.objects.push(o)
      o.visible = false
    }

    if(this.immediately) {
      this.start()
    }
  }

  update() {
    if(!this.current) {return}

    if(this.speed < this.maxSpeed) {
        this.speed += 0.003
    }
    if(this.isVertical) {
      this.current.y += this.speed

      if(this.current.y > this._settings.endY) {
        const r = Utils.randomNumber(1000, 10000)
        this.stop()

        this.nextTimer = setTimeout(() => this.next(), r)
      }
    }
  }

  stop() {
    if(this.repeat == 0 && this.repeat != -1) {
      Signals.tick.remove(this.update, this)
      return
    }

    for (let i = 0; i < this.objects.length; i++) {
      this.objects[i].visible = false
      if(this.isSpine) {
        this.objects[i].stop()
      }
    }
  }

  next() {
    this.current = this.objects[Utils.getRandomInt(0, this.objects.length - 1)]
    this.current.visible = true
    if(this.isSpine) {
      this.current.start([this.spineAnimationName], [true])
    }
    const xx = Utils.getRandomInt(0, this.settings.width)
    this.current.position.set(this.settings.startX + xx, this.settings.startY -  2 * this.current.height)
    this.repeat--
  }

  onMakeBets() {
    this.speed = 0
    Signals.tick.remove(this.update, this)
    if(!this.current) {
      this.stop()
    }
  }

  onRoundEnd() {
    this.speed = 0
    clearTimeout(this.nextTimer)
    this.nextTimer = null
    Signals.tick.remove(this.update, this)
  }

  onRoundStart() {
    this.start()
  }

  start() {
    if(!this.current) {
      const r = Utils.randomNumber(this.minDelay, this.maxDelay)
      this.stop()

      this.nextTimer = setTimeout(() => this.next(), r)
    }
    Signals.tick.add(this.update, this)
  }

  set settings(value) {
    this.immediately = value.immediately || false
    this.repeat = value.repeat ? value.repeat : -1
    this.isSpine = value.isSpine
    this.spineAnimationName = value.spineAnimationName
    this._settings = value
    this.speed = 0
    this.minDelay = value.minDelay || 0
    this.maxDelay = value.maxDelay || 0
    this.maxSpeed = value.speed
    this.isHorisontal = false
    this.isVertical = false

    if(this._settings.startX - this._settings.endX != 0) {
      this.isHorisontal = true
    }
    if(this._settings.startY - this._settings.endY != 0) {
      this.isVertical = true
    }
  }

  get settings() {
    return this._settings
  }



}
